import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPatch, operationsClient } from '@/lib/api';
import { proposalTemplateEndpoints } from '@/lib/api/endpoints';
import { proposalTemplateKeys } from '@/lib/queryKeys';
import type { ProposalTemplate, UpdateProposalTemplateDto } from '@/types/proposalTemplate';

interface UpdateProposalTemplateVars {
  id: string;
  dto: UpdateProposalTemplateDto;
}

export const useUpdateProposalTemplate = createMutationHook<
  ProposalTemplate,
  UpdateProposalTemplateVars
>({
  mutationFn: ({ id, dto }) =>
    apiPatch<ProposalTemplate, UpdateProposalTemplateDto>(
      operationsClient,
      proposalTemplateEndpoints.update(id),
      dto,
    ),
  onSuccess: (_data, { id }, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: proposalTemplateKeys.lists() });
    void queryClient.invalidateQueries({ queryKey: proposalTemplateKeys.detail(id) });
    toast.success('Proposal template updated');
  },
});
